import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Collapse,
  Flex,
  Link as ChakraLink,
  List,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import ReactGA from 'react-ga';
import '../App.scss';

export const CookieConsent = () => {
  const [noCookieSet, setNoCookieSet] = useState(false);
  const [cookieNoticeCollapse, setCookieNoticeCollapse] = useState(false);
  const [cookieRequiredNoticeCollapse, setRequiredCookieNoticeCollapse] =
    useState(false);
  const [cookies, setCookie] = useCookies(['cookie-consent']);

  useEffect(() => {
    if (cookies['cookie-consent'] === 'true') {
      ReactGA.initialize('UA-212873854-1');
      setNoCookieSet(false);
    } else if (cookies['cookie-consent'] === 'false') {
      setNoCookieSet(false);
    } else {
      setNoCookieSet(true);
    }
  }, [cookies]);

  const onCookieCloseDeny = () => {
    setCookie('cookie-consent', false);
    setNoCookieSet(false);
  };

  const onCookieCloseAccept = () => {
    ReactGA.initialize('UA-212873854-1');
    setCookie('cookie-consent', true, { maxAge: 31560000 });
    setNoCookieSet(false);
  };

  return (
    <Modal
      closeOnEsc={false}
      closeOnOverlayClick={false}
      isOpen={noCookieSet}
      onClose={onCookieCloseDeny}
    >
      <ModalOverlay />
      <ModalContent className="policy-modal">
        <ModalHeader>Cookiepolitik</ModalHeader>
        <ModalBody className="policy-content">
          <Flex flexDir="column" gap={4}>
            <Text lineHeight="1.8">
              Toft Ejendomme bruger cookies til statistik. Ved at klikke
              Accepter, accepterer du vores brug af cookies.
            </Text>
            <Button
              bg="white"
              border="1px solid var(--border)"
              borderRadius="12px"
              color="var(--fg)"
              onClick={() =>
                setRequiredCookieNoticeCollapse(!cookieRequiredNoticeCollapse)
              }
              variant={'ghost'}
            >
              Nødvendige Cookies{' '}
              {cookieRequiredNoticeCollapse ? (
                <ChevronUpIcon />
              ) : (
                <ChevronDownIcon />
              )}
            </Button>
            <Collapse in={cookieRequiredNoticeCollapse} animateOpacity>
              <Flex mt="2vw" flexDir={'row'}>
                <Box>
                  <List>
                    <Text>Service</Text>
                    <Text>Formsål</Text>
                    <Text>Udløb</Text>
                    <Text>Navn</Text>
                    <Text>Udbyder</Text>
                  </List>
                </Box>
                <Box w={'3vw'} />
                <Box>
                  <List>
                    <Text>Toft Ejendomme</Text>
                    <Text>Cookie Indstillinger</Text>
                    <Text>1 år</Text>
                    <Text>CookieConsent</Text>
                    <Text>.toftejendomme.dk</Text>
                  </List>
                </Box>
              </Flex>
            </Collapse>
            <Button
              bg="white"
              border="1px solid var(--border)"
              borderRadius="12px"
              color="var(--fg)"
              onClick={() => setCookieNoticeCollapse(!cookieNoticeCollapse)}
              variant={'ghost'}
            >
              Statistiske Cookies{' '}
              {cookieNoticeCollapse ? <ChevronUpIcon /> : <ChevronDownIcon />}
            </Button>
            <Collapse in={cookieNoticeCollapse} animateOpacity>
              <Flex mt="2vw" flexDir={'row'}>
                <Box>
                  <List>
                    <Text>Service</Text>
                    <Text>Formål</Text>
                    <Text>Privatlivspolitik</Text>
                    <Text>Udløb</Text>
                    <Text>Navn</Text>
                    <Text>Udbyder</Text>
                  </List>
                </Box>
                <Box w={'3vw'} />
                <Box>
                  <List>
                    <Text>Google Analytics</Text>
                    <Text>Besøgsstatisik</Text>
                    <ChakraLink
                      color={'blue'}
                      href="https://policies.google.com/technologies/partner-sites?hl=en"
                    >
                      Privatlivspolitik
                    </ChakraLink>
                    <Text>Et par sekunder</Text>
                    <Text>_gat</Text>
                    <Text>.toftejendomme.dk</Text>
                  </List>
                </Box>
              </Flex>
              <Flex mt="2vw" flexDir={'row'}>
                <Box>
                  <List>
                    <Text>Service</Text>
                    <Text>Formål</Text>
                    <Text>Privatlivspolitik</Text>
                    <Text>Udløb</Text>
                    <Text>Navn</Text>
                    <Text>Udbyder</Text>
                  </List>
                </Box>
                <Box w={'3vw'} />
                <Box>
                  <List>
                    <Text>Google Analytics</Text>
                    <Text>Besøgsstatisik</Text>
                    <ChakraLink
                      color={'blue'}
                      href="https://policies.google.com/technologies/partner-sites?hl=en"
                    >
                      Privatlivspolitik
                    </ChakraLink>
                    <Text>En dag</Text>
                    <Text>_gid</Text>
                    <Text>.toftejendomme.dk</Text>
                  </List>
                </Box>
              </Flex>
              <Flex mt={'2vw'} flexDir={'row'}>
                <Box>
                  <List>
                    <Text>Service</Text>
                    <Text>Formål</Text>
                    <Text>Privatlivspolitik</Text>
                    <Text>Udløb</Text>
                    <Text>Navn</Text>
                    <Text>Udbyder</Text>
                  </List>
                </Box>
                <Box w={'3vw'} />
                <Box>
                  <List>
                    <Text>Google Analytics</Text>
                    <Text>Besøgsstatisik</Text>
                    <ChakraLink
                      color={'blue'}
                      href="https://policies.google.com/technologies/partner-sites?hl=en"
                    >
                      Privatlivspolitik
                    </ChakraLink>
                    <Text>2 år</Text>
                    <Text>_ga</Text>
                    <Text>.toftejendomme.dk</Text>
                  </List>
                </Box>
              </Flex>
            </Collapse>
          </Flex>
        </ModalBody>

        <ModalFooter gap={3}>
          <Button
            bg="var(--accent-soft)"
            color="var(--fg)"
            onClick={onCookieCloseDeny}
            _hover={{ bg: '#ead4c8' }}
          >
            Accepter kun nødvendige
          </Button>
          <Button
            bg="var(--accent)"
            color="white"
            onClick={onCookieCloseAccept}
            _hover={{ bg: 'var(--accent-dark)' }}
          >
            Accepter alle
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
